<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5 class="vue-title">
          <strong>{{ $t("COMPANYINFORMATION") }}</strong>
        </h5>
      </div>
    </div>
    <b-row>
      <b-col sm="12" md="1">
        <div class="pull-left card-text margin-right-info" v-if="
              this.companyInfoForm.profile_logo &&
                this.companyInfoForm.profile_logo != 'null'
            ">
          <b-row>
            <b-col sm="12">
              <img v-lazy="companyInfoForm.profile_logo" width="100%" class="logoPadding" alt="LogoPreview" />
            </b-col>
          </b-row>
        </div>
        <div class="pull-left card-text margin-right-info" v-else >
          <b-row>
            <b-col sm="12">
              <img src="../../../assets/DEFAULTLOGO.png" width="100%" class="logoPadding" alt="defaultLogoPreview" />
            </b-col>
          </b-row>
        </div>
      </b-col>
      <b-col sm="12" md="9">
        <b-card>
          <b-form class="companyInfoBcard">
            <b-row>
              <b-col>
                <span>
                    <strong>{{ companyInfoForm.name }}</strong>
                  </span>
              </b-col>
              <b-col sm="2" v-if="checkPermisssion('PARTNER_ABOUT', false)">
                <span>
                    <img
                      src="../../../assets/Edit.svg"
                      class="editicon pull-right"
                      @click="updateCompanyInfoModal"
                      alt="editButton"
  
                    />
                  </span>
              </b-col>
            </b-row>
            <br />
            <b-row class="companyInfoBcard">
              <b-col sm="3">
                <span>
                    <strong>{{ $t("EMAIL") }}</strong>
                  </span>
              </b-col>
              <b-col sm="5">{{ companyInfoForm.email }}</b-col>
            </b-row>
            <b-row class="companyInfoBcard">
              <b-col sm="3">
                <span>
                    <strong>{{ $t("POSTALCODE") }}</strong>
                  </span>
              </b-col>
              <b-col sm="5">{{ companyInfoForm.postal_code }}</b-col>
            </b-row>
            <b-row class="companyInfoBcard">
              <b-col sm="3">
                <span>
                    <strong>{{ $t("PREFECTURES") }}</strong>
                  </span>
              </b-col>
              <b-col sm="5">{{ companyInfoForm.prefecture }}</b-col>
            </b-row>
            <b-row class="companyInfoBcard">
              <b-col sm="3">
                <span>
                    <strong>{{ $t("CITY") }}</strong>
                  </span>
              </b-col>
              <b-col sm="5">{{ companyInfoForm.city }}</b-col>
            </b-row>
            <b-row class="companyInfoBcard">
              <b-col sm="3">
                <span>
                    <strong>{{ $t("STREETADDRESS") }}</strong>
                  </span>
              </b-col>
              <b-col sm="5">{{ companyInfoForm.street_address }}</b-col>
            </b-row>
            <b-row class="companyInfoBcard">
              <b-col sm="3">
                <span>
                    <strong>{{ $t("BUILDINGNAME") }}</strong>
                  </span>
              </b-col>
              <b-col sm="5">{{ companyInfoForm.building_name }}</b-col>
            </b-row>
            <b-row class="companyInfoBcard">
              <b-col sm="3">
                <span>
                    <strong>{{ $t("MOBILE") }}</strong>
                  </span>
              </b-col>
              <b-col sm="5">{{ companyInfoForm.contact_no }}</b-col>
            </b-row>
            <br />
          </b-form>
        </b-card>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-modal size="lg" id="modal-companyUpdate" hide-footer @hidden="close">
      <template v-slot:modal-title>会社情報＞編集
</template>
      <b-form class="formTextSize" autocomplete="off">
        <b-row>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("AFFILIATEDNAME") }}</span>
              <span class="mandotry-color">*</span>
              <b-form-input
                class="inputField"
                v-model.trim="$v.companyInfoForm.name.$model"
                :maxlength="CONSTANTS.default"
                type="text"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.name"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("EMAIL") }}</span>
              <span class="mandotry-color">*</span>
              <b-form-input
                id="email"
                v-model.trim="$v.companyInfoForm.email.$model"
                class="inputField"
                @keypress="preventSpecialChar($event)"
                :maxlength="CONSTANTS.default"
                type="text"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.email"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("POSTALCODE") }}</span>
              <span class="mandotry-color">*</span>
              <b-form-input
                class="inputField"
                v-model.trim="$v.companyInfoForm.postal_code.$model"
                @keypress="isNumberValidatorPost($event)"
                @blur="checkPostalCode"
                @keydown="removeDash($event)"
                type="text"
                :maxlength="CONSTANTS.postalCode"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.postal_code"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("PREFECTURES") }}</span>
              <span class="mandotry-color">*</span>
              <b-form-input
                class="inputField"
                v-model.trim="$v.companyInfoForm.prefecture.$model"
                :maxlength="CONSTANTS.default"
                type="text"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.prefecture"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("CITY") }}</span>
              <span class="mandotry-color">*</span>
              <b-form-input
                class="inputField"
                v-model.trim="$v.companyInfoForm.city.$model"
                :maxlength="CONSTANTS.default"
                type="text"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.city"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("STREETADDRESS") }}</span>
              <span class="mandotry-color">*</span>
              <b-form-input
                class="inputField"
                v-model.trim="$v.companyInfoForm.street_address.$model"
                :maxlength="CONSTANTS.default"
                type="text"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.street_address"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("BUILDINGNAME") }}</span>
              <b-form-input
                class="inputField"
                v-model.trim="$v.companyInfoForm.building_name.$model"
                :maxlength="CONSTANTS.default"
                type="text"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.building_name"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("MOBILE") }}</span>
              <span class="mandotry-color">*</span>
              <b-form-input
                @keypress="isNumberValidatorphone($event)"
                class="inputField"
                v-model.trim="$v.companyInfoForm.contact_no.$model"
                :maxlength="CONSTANTS.MaxPhone"
                type="text"
                autocomplete="off"
              ></b-form-input>
              <show-errors
                :control="$v.companyInfoForm.contact_no"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="6">
            <b-form-group id="addressField" label-for="input-1">
              <span>{{ $t("LOGO") }}</span>
              <b-form-file
                :placeholder="$t('SELECTICON')"
                v-model.trim="$v.companyInfoForm.profile_logo.$model"
                @change="onFileChange"
                browse-text="参照"
                accept="image/x-png, image/svg+xml, image/jpeg"
                ref="myFile"
                id="imageUpload"
              ></b-form-file>
              <show-errors
                :control="$v.companyInfoForm.profile_logo"
                :field="$t('MANDATORY')"
              />
            </b-form-group>
            <p class="font-size-10">
              ファイル形式がjpeg、png、svgファイルのみ有効（最大ファイルサイズは512KB）
            </p>
          </b-col>
          <b-col md="3" v-if="this.companyInfoForm.profile_logo">
            <div class="img-top-marging">
              <img :v-if="this.url" :src="url" alt="icon" width="49px" />
              <span
                :v-if="this.url != null"
                aria-hidden="true"
                @click="clearImage"
                class="imageClose"
                >×</span
              >
            </div>
          </b-col>
        </b-row>
      </b-form>
      <hr />
      <b-row>
        <b-col>
          <b-button
            variant="outline-primary"
            size="sm"
            class="buttons-align-right btn-top-mar" 
            @click="saveCompanyInfo()"
          >
            {{ $t("ADDTO") }}
          </b-button>
          <b-button
            variant="outline-secondary"
            size="sm"
            class="buttons-align-right"
            @click="$bvModal.hide('modal-companyUpdate')"
          >
            {{ $t("CANCEL") }}
          </b-button>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
  import {
    GET_PARTNER_ABOUT,
    EDIT_PARTNER_ABOUT,
    UPDATE_PARTNERNAME
  } from "@/store/actions.type";
  import * as _ from "lodash";
  import ShowErrors from "@/components/ShowErrors";
  import {
    required,
    email,
    minLength
  } from "vuelidate/lib/validators";
  import {
    CONSTANTS
  } from "@/shared/utils";
  import {
    checkPermisssion,
    preventSpecialChar,
    isNumberValidatorphone,
    phoneDigitValidation
  } from "@/shared/utils.js";
  
  import {
    isNumberValidator
  } from "@/shared/utils.js";
  
  export default {
    name: "add-partner",
    components: {
      ShowErrors
    },
  
    data: function() {
      return {
        showCaseForm: {},
        preventSpecialChar: preventSpecialChar,
        checkPermisssion: checkPermisssion,
        CONSTANTS: null,
        isNumberValidator: isNumberValidator,
        isNumberValidatorphone: isNumberValidatorphone,
        phoneDigitValidation: phoneDigitValidation,
        isLoading: "",
        companyInfo: "",
        companyInfoForm: {
          contact_no: "",
          building_name: "",
          street_address: "",
          prefecture: "",
          city: "",
          postal_code: "",
          email: "",
          profile_logo: "",
          name: ""
        },
        url: "",
        url2: ""
      };
    },
    /*validation for the Each fields in From */
    validations: {
      companyInfoForm: {
        contact_no: {
          required,
          phoneNumber: minLength(10)
        },
        building_name: {},
        street_address: {
          required
        },
        prefecture: {
          required
        },
        city: {
          required
        },
        postal_code: {
          required,
          postalCode: minLength(8)
        },
        email: {
          required,
          email
        },
        profile_logo: {},
        name: {
          required
        }
      }
    },
    methods: {
      /* Remove digit when user removing dash */
      removeDash(evt) {
        if (this.companyInfoForm.postal_code.length == 4) {
          this.companyInfoForm.postal_code = this.companyInfoForm.postal_code.substring(
            0,
            this.companyInfoForm.postal_code.length - 1
          );
        }
      },
      /*Postal code validating. Adding - after */
      isNumberValidatorPost(evt) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
  
        if (charCode > 31 && (charCode < 48 || charCode > 57)) {
          evt.preventDefault();
        }
        if (this.companyInfoForm.postal_code.length == 3) {
          this.companyInfoForm.postal_code =
            this.companyInfoForm.postal_code + "-";
        } else if (this.companyInfoForm.postal_code.length < 3) {
          this.companyInfoForm.postal_code = this.companyInfoForm.postal_code.replace(
            "-",
            ""
          );
        }
      },
      /* On focus out do postal code format */
      checkPostalCode() {
        let temp = this.companyInfoForm.postal_code.replace("-", "");
        if (temp.length > 3) {
          let startString = temp.slice(0, 3);
          let endString = temp.slice(3, 7);
          this.companyInfoForm.postal_code = startString + "-" + endString;
        }
      },
      /**
       * To get the Details of the Company
       * Input need to call the  GET_PARTNER_ABOUT action
       * Output @param {object}  response company Information
       */
      async getPartnerDetails() {
        let response = await this.$store.dispatch(GET_PARTNER_ABOUT, {});
        this.isLoading.hide();
        if (_.get(response, "status", false)) {
          let about = response.about;
          this.companyInfoForm = {
            contact_no: _.get(about, "contact_no", ""),
            building_name: _.get(about, "address.building_name", "") == "null" ?
              "" :
              _.get(about, "address.building_name", ""),
            street_address: _.get(about, "address.street_address", ""),
            prefecture: _.get(about, "address.prefecture", ""),
            city: _.get(about, "address.city", ""),
            postal_code: _.get(about, "address.postal_code", ""),
            email: _.get(about, "email", ""),
            profile_logo: _.get(about, "partner_logo", ""),
            name: _.get(about, "name", "")
          };
          this.url = _.get(about, "partner_logo", "");
        } else {
          this.$toast.error({
            message: _.get(response, "message", "")
          });
        }
      },
      /**
       * To get clear image when user click on clear icon in Modal
       * Input
       * Output clears the image variable
       */
      clearImage() {
        this.url = "";
        this.companyInfoForm.profile_logo = "";
        document.getElementById("imageUpload").value = "";
      },
      /*Rerendrering the Componet */
      close() {
        this.renderComponent = false;
        this.companyInfoForm = Object.assign({}, this.showCaseForm);
        this.url = this.url2;
        this.$nextTick(() => {
          // Add the component back in
          this.renderComponent = true;
        });
      },
      /**
       * Show modal-companyUpdate Modal
       * Input @param {object} this.companyInfoForm the object contains the company information
       * Output PopUp the modal-companyUpdate
       */
      updateCompanyInfoModal() {
        this.showCaseForm = Object.assign({}, this.companyInfoForm);
        this.url2 = this.url;
        this.$bvModal.show("modal-companyUpdate");
      },
      /**
       * Sumbitting the Filled Form
       * Input @param {object} object  this.createPartner object which is Edited  by the user  in modal-companyUpdate
       * Output @param {boolean}   response Boolean status Api call (true =  success, false = failed)
       */
      async saveCompanyInfo(evt) {
        if (phoneDigitValidation(this.companyInfoForm.contact_no) === true) {
          this.$toast.error({
            message: this.$t("INVALIDPHONENO")
          });
        } else {
          this.$v.$touch();
          if (!this.$v.$invalid) {
            this.isLoading = this.$loading.show({
              loader: "dots",
              color: "#007bff"
            });
            this.$bvModal.hide("modal-companyUpdate");
            let cname = this.companyInfoForm.name;
            let formData = new FormData();
            formData.append("contact_no", this.companyInfoForm.contact_no);
            formData.append(
              "building_name",
              this.companyInfoForm.building_name == null ?
              "" :
              this.companyInfoForm.building_name
            );
            formData.append(
              "street_address",
              this.companyInfoForm.street_address
            );
            formData.append("prefecture", this.companyInfoForm.prefecture);
            formData.append("city", this.companyInfoForm.city);
            formData.append("postal_code", this.companyInfoForm.postal_code);
            formData.append("email", this.companyInfoForm.email);
            formData.append("profile_logo", this.companyInfoForm.profile_logo);
            formData.append("name", this.companyInfoForm.name);
            formData.append("_method", "PUT");
            let response = await this.$store.dispatch(
              EDIT_PARTNER_ABOUT,
              formData
            );
            this.isLoading.hide();
  
            if (_.get(response, "status", false)) {
              this.$toast.success({
                message: _.get(response, "message", "")
              });
              this.getPartnerDetails();
              await this.$store.dispatch(UPDATE_PARTNERNAME, cname).then(() => {
                setTimeout(function() {
                  window.location.reload();
                }, 1000);
              });
            } else {
              this.$toast.error({
                message: _.get(response, "message", "")
              });
            }
          }
        }
      },
      /**
       * Valiadation of Image(when user selects the image from his Device)
       * Input @param {Media} e  select Image from the Device
       * Output @param {Media}   Image return the Image if it meets the Requiremets otherwise returns "ファイル形式がjpeg、png、svgファイルのみ有効"
       * or "this.$t("UPLOADLIMITERROR")"
       */
  
      onFileChange(e) {
        const file = e.target.files[0];
        var fileName = document.getElementById("imageUpload").value;
        var idxDot = fileName.lastIndexOf(".") + 1;
        var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
        if (!(
            extFile == "jpg" ||
            extFile == "jpeg" ||
            extFile == "png" ||
            extFile == "svg"
          )) {
          this.$toast.error({
            message: "ファイル形式がjpeg、png、svgファイルのみ有効"
          });
          document.getElementById("imageUpload").value = "";
  
          this.url = null;
          this.companyInfoForm.profile_logo = null;
          return;
        }
  
        this.imageSize = Math.round(file.size / 1000);
        if (this.imageSize > CONSTANTS.imageSizeMax) {
          this.$toast.error({
            message: this.$t("UPLOADLIMITERROR")
          });
          this.url = null;
          document.getElementById("imageUpload").value = "";
        } else {
          this.url = URL.createObjectURL(file);
        }
      }
    },
    created() {
      this.CONSTANTS = CONSTANTS;
      this.isLoading = this.$loading.show({
        loader: "dots",
        color: "#007bff"
      });
      this.getPartnerDetails();
    }
  };
</script>

<style>
  .dragArea {
    min-height: 100px;
    background: #ededed;
    padding: 10px;
  }
  
  .list-group-item {
    margin-bottom: 6px;
  }
  
  .imageClose {
    margin-left: 16px;
    font-size: 1.5rem;
    font-weight: 700;
    line-height: 1;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    cursor: pointer;
  }
  
  .editicon {
    height: 20px;
    width: 20px;
  }
  
  .logoPadding {
    margin-bottom: 15px;
  }
  .margin-right-info{
    margin-right:10px;
  }
  .font-size-10{
    font-size: 10px;
  }
  .img-top-marging{
    margin-top: 20px;
  }
  .btn-top-mar{
    margin-right:15px
  }
</style>
